<template>
  <v-container fluid>
    <v-row>
      <v-col xs12>
        <v-card>
          <h1>Resolving QR.code</h1>
          <h2>Loading Data...</h2>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import store from '@/store/index'
export default {
  name: 'QRCodeRouter',
  mounted(){
    let query = '?code=' + this.$route.query.code + '&signature=' + this.$route.query.signature;
    store.dispatch('Project/resolveTag', { query: query });
  },
  methods: {}
};
</script>
